// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"82":"e8dec7efcdc6dc08","657":"1bd95b5a858d1212","1343":"4a41f2f8561b3660","3527":"0c307e90de1d1b22"}[chunkId] + ".css";
};